/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable no-sparse-arrays */
import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import '@twygs/shared/micro-learning/styles/animations.css';
import App from './App';
import UnauthorizedModal from './components/UnauthorizedModal';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
    <UnauthorizedModal />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
